import axios from "axios";
import  config  from "../../config";
const apiurl = config.ADMIN_BASE_URL;

// ------------------------fetchInterests------------------------
export const fetchInterests = async () => {
  const token = localStorage.getItem("cookies");
  try {
    const response = await axios.get(`${apiurl}/interests`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching interests:", error);
    throw error;
  }
};

// --------------------------------updateInterestImage--------------------------------------
export const updateInterestImage = async (id, data) => {
  const token = localStorage.getItem("cookies");
//   console.log("Data", data);
  try {
    const response = await axios.post(`${apiurl}/interests/update/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("Image Updated", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating image:", error);
    throw error;
  }
};
